import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import {
    animateText,
    onSideNavChange,
    selectedItemMenu,
} from 'src/app/core/animations/animations-menu';
import { MenuService } from 'src/app/core/services/menu/menu.service';
import { AuthService } from '../../core/auth/auth.service';
import { Role } from '../../core/auth/roles';
import { IconName } from '../mb-icon/icon.type';
interface Page {
    link: string;
    name: string;
    icon: IconName;
    state: string;
    allowedRoles: Role[];
}

@Component({
    selector: 'app-left-menu',
    templateUrl: './left-menu.component.html',
    styleUrls: ['./left-menu.component.scss'],
    animations: [onSideNavChange, animateText, selectedItemMenu],
})
export class LeftMenuComponent {
    public sideNavState: boolean;
    public linkText: boolean;
    iconsMenu = [{ name: 'profile' }, { name: 'team' }];
    public pages: Page[] = [
        {
            name: 'Conta Alternativa',
            link: 'alternative-account',
            icon: 'profile',
            state: 'noSelectedItemMenu',
            allowedRoles: [Role.SysAdmin],
        },
    ];

    constructor(
        private _sidenavService: MenuService,
        public router: Router,
        private authService: AuthService
    ) {
        // const roles = this.authService.getRolesArray();
        // this.pages = this.pages.filter((page) =>
        //     roles.some((r) => page.allowedRoles.includes(r as Role))
        // );
        this.checkRouteAndSelectItemMenu();
        this.sideNavState = false;
        this.linkText = false;
    }

    onSinenavToggle() {
        this.sideNavState = !this.sideNavState;

        setTimeout(() => {
            this.linkText = this.sideNavState;
        }, 200);
        this._sidenavService.sideNavState$.next(this.sideNavState);
    }

    goTo(link: string) {
        this.router.navigateByUrl(link);
    }

    checkRouteAndSelectItemMenu() {
        this.router.events.pipe(
            filter((e): e is NavigationEnd => e instanceof NavigationEnd),
            map((event) => {
                this.pages.map((itemMenu, index) => {
                    if (event.url === '/' + itemMenu.link) {
                        this.pages[index].state = 'selectedItemMenu';
                    } else if (event.url.split('/')[1] === itemMenu.link) {
                        this.pages[index].state = 'selectedItemMenu';
                    } else {
                        this.pages[index].state = 'noSelectedItemMenu';
                    }
                });
            })
        );
    }
}
